import { useLazyQuery, useMutation } from "@apollo/client";
import { STOCK_UNIT_BY_QR_CODE, UPDATE_STOCK_UNIT } from "../stock-unit.queries";
import {
  StockUnitByQrCodeQuery,
  StockUnitByQrCodeQueryVariables,
} from "../../../__generated__/StockUnitByQrCodeQuery";
import {
  UpdateStockUnitMutation,
  UpdateStockUnitMutationVariables,
} from "../../../__generated__/UpdateStockUnitMutation";

export const useTransferStockUnit = () => {
  const [lookup] = useLazyQuery<StockUnitByQrCodeQuery, StockUnitByQrCodeQueryVariables>(
    STOCK_UNIT_BY_QR_CODE
  );
  const [mutate, { loading }] = useMutation<
    UpdateStockUnitMutation,
    UpdateStockUnitMutationVariables
  >(UPDATE_STOCK_UNIT, {
    refetchQueries: "active",
  });

  const transferFromScan = async (qrCode: string, warehouseId: number) => {
    try {
      const { data: lookupData } = await lookup({ variables: { qrCode } });
      const stockUnit = lookupData?.stockUnitByQrCode?.result;

      if (!lookupData?.stockUnitByQrCode?.ok || !stockUnit) {
        return {
          success: false,
          error: lookupData?.stockUnitByQrCode?.error ?? "Code QR inconnu",
        };
      }

      if (stockUnit.exitedAt) {
        return { success: false, error: "Ce lot est déjà sorti du stock" };
      }

      if (stockUnit.warehouse?.id === warehouseId) {
        return {
          success: false,
          error: "Ce lot est déjà dans cet entrepôt",
        };
      }

      const { data } = await mutate({
        variables: { id: stockUnit.id, input: { warehouseId } },
      });

      if (!data?.updateStockUnit?.ok) {
        return {
          success: false,
          error: data?.updateStockUnit?.error ?? "Erreur inconnue",
        };
      }

      return {
        success: true,
        productName: stockUnit.product?.name,
        batchNumber: stockUnit.batchNumber,
        fromWarehouseName: stockUnit.warehouse?.name,
      };
    } catch (error: any) {
      return {
        success: false,
        error: error?.message ?? "Une erreur est survenue",
      };
    }
  };

  return { transferFromScan, loading };
};
